/** 平台分组看板配置：知乎 / 头条 / 百家号共用 GenericPlatformGroupBoard */
import { publishV2Api } from '../api'
import {
  normalizeXhsAccountBoard,
  normalizeXhsGroupBoard,
  normalizeXhsNote,
} from './boardNormalize'

export const PLATFORM_GROUP_BOARD = {
  zhihu: {
    key: 'zhihu',
    label: '知乎',
    titleFallback: '知乎分组看板',
    ranges: [7, 14, 30, 0],
    defaultRange: 7,
    fetchBoard: (groupId, params) => publishV2Api.getZhihuGroupDatacenterBoard(groupId, params),
    heroKpis: [
      { label: '阅读', path: 'metrics.pv' },
      { label: '播放', path: 'metrics.play' },
      { label: '赞同', path: 'metrics.upvote' },
      { label: '评论', path: 'metrics.comment' },
      { label: '关注者', path: 'fans.followers' },
    ],
    memberColumns: [
      { prop: 'followers', label: '关注者', width: 90 },
      { prop: 'pv', label: '阅读', width: 96 },
      { prop: 'upvote', label: '赞同', width: 80 },
      { prop: 'like', label: '喜欢', width: 72 },
      { prop: 'comment', label: '评论', width: 72 },
      { prop: 'collect', label: '收藏', width: 72 },
    ],
    memberSortOptions: [
      { value: 'pv_desc', label: '阅读↓', prop: 'pv', order: 'desc' },
      { value: 'upvote_desc', label: '赞同↓', prop: 'upvote', order: 'desc' },
      { value: 'followers_desc', label: '关注者↓', prop: 'followers', order: 'desc' },
      { value: 'comment_desc', label: '评论↓', prop: 'comment', order: 'desc' },
    ],
    defaultMemberSort: 'pv_desc',
    kpiTabs: {
      traffic: [
        { key: 'pv', label: '阅读' },
        { key: 'play', label: '播放' },
        { key: 'show', label: '展现' },
      ],
      engage: [
        { key: 'upvote', label: '赞同' },
        { key: 'like', label: '喜欢' },
        { key: 'comment', label: '评论' },
        { key: 'collect', label: '收藏' },
        { key: 'share', label: '分享' },
        { key: 're_pin', label: '转发' },
      ],
    },
    workColumns: [
      { prop: 'views', label: '阅读', width: 88 },
      { prop: 'likes', label: '赞同', width: 80 },
      { prop: 'comments', label: '评论', width: 72 },
      { prop: 'collects', label: '收藏', width: 72 },
      { prop: 'shares', label: '分享', width: 72 },
    ],
    workSortOptions: [
      { value: 'views_desc', label: '阅读↓', prop: 'views', order: 'desc' },
      { value: 'likes_desc', label: '赞同↓', prop: 'likes', order: 'desc' },
      { value: 'comments_desc', label: '评论↓', prop: 'comments', order: 'desc' },
    ],
    defaultWorkSort: 'views_desc',
  },
  toutiao: {
    key: 'toutiao',
    label: '头条',
    titleFallback: '头条分组看板',
    ranges: [7, 14, 30],
    defaultRange: 7,
    fetchBoard: (groupId, params) => publishV2Api.getToutiaoGroupDatacenterBoard(groupId, params),
    heroKpis: [
      { label: '展现', path: 'metrics.impression' },
      { label: '阅读', path: 'metrics.read' },
      { label: '点赞', path: 'metrics.like' },
      { label: '涨粉', path: 'fans.new_fans' },
      { label: '粉丝', path: 'fans.followers' },
    ],
    memberColumns: [
      { prop: 'followers', label: '粉丝', width: 88 },
      { prop: 'impression', label: '展现', width: 96 },
      { prop: 'read', label: '阅读', width: 96 },
      { prop: 'like', label: '点赞', width: 80 },
      { prop: 'comment', label: '评论', width: 72 },
    ],
    memberSortOptions: [
      { value: 'read_desc', label: '阅读↓', prop: 'read', order: 'desc' },
      { value: 'impression_desc', label: '展现↓', prop: 'impression', order: 'desc' },
      { value: 'like_desc', label: '点赞↓', prop: 'like', order: 'desc' },
      { value: 'followers_desc', label: '粉丝↓', prop: 'followers', order: 'desc' },
    ],
    defaultMemberSort: 'read_desc',
    kpiTabs: {
      traffic: [
        { key: 'impression', label: '展现' },
        { key: 'read', label: '阅读' },
      ],
      engage: [
        { key: 'like', label: '点赞' },
        { key: 'comment', label: '评论' },
        { key: 'share', label: '分享' },
      ],
    },
    workColumns: [
      { prop: 'views', label: '阅读', width: 88 },
      { prop: 'likes', label: '点赞', width: 80 },
      { prop: 'comments', label: '评论', width: 72 },
      { prop: 'shares', label: '分享', width: 72 },
    ],
    workSortOptions: [
      { value: 'views_desc', label: '阅读↓', prop: 'views', order: 'desc' },
      { value: 'likes_desc', label: '点赞↓', prop: 'likes', order: 'desc' },
      { value: 'comments_desc', label: '评论↓', prop: 'comments', order: 'desc' },
    ],
    defaultWorkSort: 'views_desc',
  },
  baijiahao: {
    key: 'baijiahao',
    label: '百家号',
    titleFallback: '百家号分组看板',
    ranges: [7, 30],
    defaultRange: 7,
    fetchBoard: (groupId, params) => publishV2Api.getBaijiahaoGroupDatacenterBoard(groupId, params),
    heroKpis: [
      { label: '阅读', path: 'metrics.view', alt: 'overview.view' },
      { label: '点赞', path: 'metrics.like' },
      { label: '评论', path: 'metrics.comment' },
      { label: '投稿', path: 'metrics.publish', alt: 'overview.publish' },
      { label: '粉丝', path: 'overview.followers' },
    ],
    memberColumns: [
      { prop: 'followers', label: '粉丝', width: 88 },
      { prop: 'view', label: '阅读', width: 96 },
      { prop: 'like', label: '点赞', width: 80 },
      { prop: 'publish', label: '投稿', width: 72 },
    ],
    memberSortOptions: [
      { value: 'view_desc', label: '阅读↓', prop: 'view', order: 'desc' },
      { value: 'like_desc', label: '点赞↓', prop: 'like', order: 'desc' },
      { value: 'followers_desc', label: '粉丝↓', prop: 'followers', order: 'desc' },
    ],
    defaultMemberSort: 'view_desc',
    kpiTabs: {
      traffic: [
        { key: 'view', label: '阅读' },
        { key: 'recommend', label: '推荐' },
      ],
      engage: [
        { key: 'like', label: '点赞' },
        { key: 'comment', label: '评论' },
        { key: 'share', label: '分享' },
      ],
      publish: [
        { key: 'publish', label: '投稿' },
      ],
    },
    workColumns: [
      { prop: 'views', label: '阅读', width: 88 },
      { prop: 'likes', label: '点赞', width: 80 },
      { prop: 'comments', label: '评论', width: 72 },
    ],
    workSortOptions: [
      { value: 'views_desc', label: '阅读↓', prop: 'views', order: 'desc' },
      { value: 'likes_desc', label: '点赞↓', prop: 'likes', order: 'desc' },
    ],
    defaultWorkSort: 'views_desc',
  },
  xhs: {
    key: 'xiaohongshu',
    routeKey: 'xhs',
    crumbPlatform: 'xhs',
    accountPlatform: 'xiaohongshu',
    label: '小红书',
    titleFallback: '小红书分组看板',
    ranges: [7, 30],
    defaultRange: 7,
    fetchBoard: (groupId, params) => publishV2Api.getXhsGroupDatacenterBoard(groupId, params),
    normalize: normalizeXhsGroupBoard,
    heroKpis: [
      { label: '观看', path: 'metrics.view_count' },
      { label: '曝光', path: 'metrics.impl_count' },
      { label: '点赞', path: 'metrics.like_count' },
      { label: '涨粉', path: 'metrics.rise_fans_count', alt: 'fans.rise_fans_count' },
      { label: '总粉丝', path: 'fans.fans_count' },
    ],
    memberColumns: [
      { prop: 'followers', label: '粉丝', width: 90 },
      { prop: 'impl_count', label: '曝光', width: 100 },
      { prop: 'view_count', label: '观看', width: 100 },
      { prop: 'like_count', label: '点赞', width: 90 },
      { prop: 'rise_fans_count', label: '涨粉', width: 80 },
    ],
    memberSortOptions: [
      { value: 'view_count_desc', label: '观看↓', prop: 'view_count', order: 'desc' },
      { value: 'impl_count_desc', label: '曝光↓', prop: 'impl_count', order: 'desc' },
      { value: 'like_count_desc', label: '点赞↓', prop: 'like_count', order: 'desc' },
      { value: 'followers_desc', label: '粉丝↓', prop: 'followers', order: 'desc' },
    ],
    defaultMemberSort: 'view_count_desc',
    kpiTabs: {
      traffic: [
        { key: 'view_count', label: '观看' },
        { key: 'impl_count', label: '曝光' },
      ],
      engage: [
        { key: 'like_count', label: '点赞' },
        { key: 'rise_fans_count', label: '涨粉' },
      ],
    },
    workColumns: [
      { prop: 'imp_count', label: '曝光', width: 88 },
      { prop: 'read_count', label: '观看', width: 88 },
      { prop: 'like_count', label: '点赞', width: 72 },
      { prop: 'increase_fans_count', label: '涨粉', width: 72 },
    ],
    workSortOptions: [
      { value: 'read_count_desc', label: '观看↓', prop: 'read_count', order: 'desc' },
      { value: 'imp_count_desc', label: '曝光↓', prop: 'imp_count', order: 'desc' },
      { value: 'like_count_desc', label: '点赞↓', prop: 'like_count', order: 'desc' },
    ],
    defaultWorkSort: 'read_count_desc',
    workIdField: 'note_id',
  },
  douyin: {
    key: 'douyin',
    routeKey: 'douyin',
    crumbPlatform: 'douyin',
    label: '抖音',
    titleFallback: '抖音分组看板',
    ranges: [1, 7, 30],
    defaultRange: 7,
    rangeLabels: { 1: '昨天' },
    fetchBoard: (groupId, params) => publishV2Api.getDouyinGroupDatacenterBoard(groupId, params),
    heroKpis: [
      { label: '播放', path: 'metrics.play' },
      { label: '点赞', path: 'metrics.like' },
      { label: '封面点击率', path: 'metrics.cover_click_rate', format: 'pct' },
      { label: '涨粉', path: 'fans.new_fans' },
      { label: '总粉丝', path: 'fans.followers' },
    ],
    memberColumns: [
      { prop: 'followers', label: '粉丝', width: 88 },
      { prop: 'play', label: '播放', width: 96 },
      { prop: 'cover_show', label: '曝光', width: 96 },
      { prop: 'like', label: '点赞', width: 80 },
      { prop: 'comment', label: '评论', width: 72 },
      { prop: 'new_fans', label: '涨粉', width: 72 },
      { prop: 'cover_click_rate', label: '封面点击率', width: 100, format: 'pct' },
      { prop: 'interact_rate', label: '互动率', width: 88, format: 'pct' },
    ],
    memberSortOptions: [
      { value: 'play_desc', label: '播放↓', prop: 'play', order: 'desc' },
      { value: 'like_desc', label: '点赞↓', prop: 'like', order: 'desc' },
      { value: 'followers_desc', label: '粉丝↓', prop: 'followers', order: 'desc' },
      { value: 'new_fans_desc', label: '涨粉↓', prop: 'new_fans', order: 'desc' },
    ],
    defaultMemberSort: 'play_desc',
    kpiTabs: {
      traffic: [
        { key: 'play', label: '播放' },
        { key: 'cover_show', label: '曝光' },
      ],
      engage: [
        { key: 'like', label: '点赞' },
        { key: 'comment', label: '评论' },
        { key: 'new_fans', label: '涨粉' },
      ],
    },
    workColumns: [
      { prop: 'cover_show', label: '曝光', width: 88 },
      { prop: 'views', label: '播放', width: 88 },
      { prop: 'cover_click_rate', label: '封面点击率', width: 100, format: 'pct' },
      { prop: 'likes', label: '点赞', width: 72 },
      { prop: 'comments', label: '评论', width: 72 },
      { prop: 'rise_fans', label: '涨粉', width: 72 },
    ],
    workSortOptions: [
      { value: 'views_desc', label: '播放↓', prop: 'views', order: 'desc' },
      { value: 'likes_desc', label: '点赞↓', prop: 'likes', order: 'desc' },
      { value: 'comments_desc', label: '评论↓', prop: 'comments', order: 'desc' },
    ],
    defaultWorkSort: 'views_desc',
    workIdField: 'item_id',
  },
}

export const PLATFORM_ACCOUNT_BOARD = {
  zhihu: {
    key: 'zhihu',
    label: '知乎',
    creatorLabel: '知乎创作者',
    ranges: [7, 14, 30, 0],
    defaultRange: 7,
    fetchBoard: (accountId, params) => publishV2Api.getZhihuDatacenterBoard(accountId, params),
    heroKpis: [
      { label: '阅读', path: 'metrics.pv' },
      { label: '播放', path: 'metrics.play' },
      { label: '赞同', path: 'metrics.upvote' },
      { label: '关注者', path: 'fans.followers', alt: 'account.followers' },
    ],
    metricGroups: [
      { title: '流量', items: [{ key: 'pv', label: '阅读总量' }, { key: 'play', label: '播放总量' }] },
      { title: '互动', items: [
        { key: 'upvote', label: '赞同总量' }, { key: 'like', label: '喜欢总量' },
        { key: 'comment', label: '评论总量' }, { key: 'collect', label: '收藏总量' },
        { key: 'share', label: '分享总量' }, { key: 're_pin', label: '转发总数' },
      ] },
    ],
    showPortrait: true,
    workColumns: [
      { prop: 'views', label: '阅读', width: 90 },
      { prop: 'likes', label: '赞同', width: 90 },
      { prop: 'comments', label: '评论', width: 80 },
      { prop: 'collects', label: '收藏', width: 80 },
    ],
    topWorkProp: 'views',
    topWorkLabel: '阅读',
  },
  toutiao: {
    key: 'toutiao',
    label: '头条',
    creatorLabel: '头条创作者',
    ranges: [7, 14, 30],
    defaultRange: 7,
    fetchBoard: (accountId, params) => publishV2Api.getToutiaoDatacenterBoard(accountId, params),
    heroKpis: [
      { label: '展现', path: 'metrics.impression' },
      { label: '阅读', path: 'metrics.read' },
      { label: '点赞', path: 'metrics.like' },
      { label: '粉丝', path: 'fans.followers', alt: 'account.followers' },
    ],
    metricGroups: [
      { title: '流量', items: [{ key: 'impression', label: '展现' }, { key: 'read', label: '阅读' }] },
      { title: '互动', items: [{ key: 'like', label: '点赞' }, { key: 'comment', label: '评论' }, { key: 'share', label: '分享' }] },
    ],
    workColumns: [
      { prop: 'views', label: '阅读', width: 90 },
      { prop: 'likes', label: '点赞', width: 80 },
      { prop: 'comments', label: '评论', width: 80 },
      { prop: 'shares', label: '分享', width: 80 },
    ],
    topWorkProp: 'views',
    topWorkLabel: '阅读',
  },
  baijiahao: {
    key: 'baijiahao',
    label: '百家号',
    creatorLabel: '百家号创作者',
    ranges: [7, 30],
    defaultRange: 7,
    fetchBoard: (accountId, params) => publishV2Api.getBaijiahaoDatacenterBoard(accountId, params),
    heroKpis: [
      { label: '阅读', path: 'metrics.view', alt: 'overview.view' },
      { label: '点赞', path: 'metrics.like' },
      { label: '评论', path: 'metrics.comment' },
      { label: '粉丝', path: 'overview.followers', alt: 'account.followers' },
    ],
    metricGroups: [
      { title: '流量', items: [{ key: 'view', label: '阅读' }, { key: 'recommend', label: '推荐' }] },
      { title: '互动', items: [{ key: 'like', label: '点赞' }, { key: 'comment', label: '评论' }, { key: 'share', label: '分享' }] },
    ],
    workColumns: [
      { prop: 'views', label: '阅读', width: 90 },
      { prop: 'likes', label: '点赞', width: 80 },
      { prop: 'comments', label: '评论', width: 80 },
    ],
    topWorkProp: 'views',
    topWorkLabel: '阅读',
  },
  xhs: {
    key: 'xhs',
    label: '小红书',
    creatorLabel: '小红书创作者',
    ranges: [7, 30],
    defaultRange: 7,
    fetchBoard: (accountId, params) => publishV2Api.getXhsDatacenterBoard(accountId, params),
    normalize: normalizeXhsAccountBoard,
    showPortrait: true,
    fansDeltaLabel: '窗口涨粉',
    heroKpis: [
      { label: '观看', path: 'metrics.view_count' },
      { label: '曝光', path: 'metrics.impl_count' },
      { label: '点赞', path: 'metrics.like_count' },
      { label: '粉丝', path: 'account.followers' },
    ],
    metricGroups: [
      { title: '流量', items: [{ key: 'view_count', label: '观看' }, { key: 'impl_count', label: '曝光' }] },
      { title: '互动', items: [{ key: 'like_count', label: '点赞' }, { key: 'collect_count', label: '收藏' }, { key: 'comment_count', label: '评论' }] },
    ],
    workColumns: [
      { prop: 'read_count', label: '观看', width: 90 },
      { prop: 'imp_count', label: '曝光', width: 90 },
      { prop: 'like_count', label: '点赞', width: 80 },
      { prop: 'increase_fans_count', label: '涨粉', width: 80 },
    ],
    topWorkProp: 'read_count',
    topWorkLabel: '观看',
    workIdField: 'note_id',
  },
  douyin: {
    key: 'douyin',
    label: '抖音',
    creatorLabel: '抖音创作者',
    ranges: [1, 7, 30],
    defaultRange: 7,
    rangeLabels: { 1: '昨天' },
    fetchBoard: (accountId, params) => publishV2Api.getDouyinDatacenterBoard(accountId, params),
    heroKpis: [
      { label: '播放', path: 'metrics.play' },
      { label: '点赞', path: 'metrics.like' },
      { label: '涨粉', path: 'fans.new_fans' },
      { label: '粉丝', path: 'fans.followers', alt: 'account.followers' },
    ],
    metricGroups: [
      { title: '流量', items: [{ key: 'play', label: '播放' }, { key: 'cover_show', label: '曝光' }] },
      { title: '互动', items: [{ key: 'like', label: '点赞' }, { key: 'comment', label: '评论' }, { key: 'share', label: '分享' }] },
    ],
    workColumns: [
      { prop: 'views', label: '播放', width: 90 },
      { prop: 'likes', label: '点赞', width: 80 },
      { prop: 'comments', label: '评论', width: 80 },
      { prop: 'shares', label: '分享', width: 80 },
    ],
    topWorkProp: 'views',
    topWorkLabel: '播放',
    workIdField: 'item_id',
  },
}

export const PLATFORM_WORK_BOARD = {
  xhs: {
    key: 'xhs',
    paramKey: 'noteId',
    fetchWork: (accountId, itemId, params) => publishV2Api.getXhsDatacenterNote(accountId, itemId, params),
    normalize: normalizeXhsNote,
    itemLabel: '笔记详情',
  },
  douyin: {
    key: 'douyin',
    paramKey: 'itemId',
    fetchWork: (accountId, itemId, params) => publishV2Api.getDouyinDatacenterWork(accountId, itemId, params),
    itemLabel: '作品详情',
  },
}

export function resolveBoardPath(payload, path, alt) {
  const dig = (root, p) => {
    if (!p) return undefined
    return p.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), root)
  }
  const bag = {
    metrics: payload?.metrics || {},
    fans: payload?.fans_overview || {},
    overview: payload?.overview || {},
    account: payload?.account || {},
  }
  const primary = dig(bag, path)
  if (primary != null && primary !== '') return primary
  if (alt) return dig(bag, alt)
  return 0
}
